import Link from 'next/link';
import React from 'react';

import { Musician, NotesCardQueryData } from '@shared/types';
import { H2, classNameButtonFigure } from '@shared/ui';

import styles from './similar-musicians.module.css';

interface Props {
  similarMusicians: Musician[];
  data: NotesCardQueryData['data'];
}

const SimilarMusicians = React.forwardRef<HTMLDivElement | null, Props>(
  ({ similarMusicians, data }, ref) => {
    if (!similarMusicians) return null;

    return (
      <div className={styles.container} ref={ref}>
        <div className={styles.similar}>
          <H2 className={styles.title}>{data.CT_CPV_CATALOG_ANALOG_BACK}</H2>
          <div className={styles.buttonsContainerWrap}>
            <div className={styles.buttonsContainer}>
              {similarMusicians.map((m: Musician) => (
                <Link key={m.id} href={m.url} className={classNameButtonFigure} prefetch={false}>
                  {m.title}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  },
);

SimilarMusicians.displayName = 'similarMusicians';

export default SimilarMusicians;
